<mat-form-field class="fuse-mat-no-subscript" [ngClass]="classes" [formGroup]="form">
    <mat-label>Enter a date range</mat-label>
    <mat-date-range-input [rangePicker]="picker">
        <input matStartDate placeholder="Start date" />
        <input matEndDate placeholder="End date" />
    </mat-date-range-input>
    <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker
        [panelClass]="'custom-mat-datepicker'"
        #picker
        color="accent"
        [calendarHeaderComponent]="VuiCalendarHeaderComponent"
    ></mat-date-range-picker>
</mat-form-field>
